import React from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
// import { globalServices } from "../../../../../Services/global.service";
import { storeService } from "../../../../../Services/store.service";

const StoreInput = ({
   stores,
   errors,
   control,
   // setProducts,
   setValues,
   setLoadModal,
   setModalValidationMsg,
}) => {
   const { t: translator } = useTranslation();

   return (
      <div className="form-group">
         <label>{translator("InitialState-Store")}</label>
         <Controller
            as={Select}
            options={
               stores &&
               stores.map((p) => ({
                  id: p.id,
                  label: p.name,
                  value: p.id,
               }))
            }
            isDisabled={stores.length === 0}
            name="storeId"
            placeholder={translator("Select-Store")}
            rules={{
               validate: function (value) {
                  if (!value) return false;
                  return value.value === null ? false : true;
               },
            }}
            control={control}
            onChange={function (event) {
               setModalValidationMsg("");
               // globalServices
               //    .getFilterProducts(event[0].id, 1)
               //    .then((res) => setProducts(res.data.data))
               //    .catch((err) => console.log(err));

               storeService
                  .getById(event[0].id)
                  .then((res) => {
                     setValues({
                        storeId: event[0].id,
                        tenantId: res.data.tenantId,
                        priceListId: res.data.priceListId,
                     });
                     setLoadModal(true);
                  })
                  .catch((err) => console.log(err));

               return event[0];
            }}
         />
         {errors.storeId && errors.storeId.type === "validate" && (
            <p className="text-danger">
               {translator("ValidationMsg-RequiredField")}
            </p>
         )}
      </div>
   );
};

export default StoreInput;
